import { Component, Input, Inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { fadeOutAnimation } from '../_animations/fade-out.animation';
import { AuthService } from './../auth/auth.service';

@Component({
    selector: 'ngbd-otp-validate-modal',
    template: `
    <div class="modal-header">
      <div class="modal-title">
        <fa-icon [icon]="['fas', 'key']" class="me-2"></fa-icon>{{ 'label.fyll-i-engangskod' | translate }}
      </div>
    </div>
    <div class="modal-body">
      <label class="otp-code" for="otp">{{ 'label.engangskod' | translate }}
        <input type="text" maxlength="6" required [(ngModel)]="otp" [style.background-color]="!otp ? 'var(--lh-warning-soft)' : otp.length === 6 ? 'var(--lh-emerald-soft)' : ''">
      </label>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary btn-modal" (click)="ok()" [disabled]="!otp || otp.length < 6">{{ 'button.fortsatt' | translate }}</button>
      <button type="button" class="btn btn-danger btn-modal" (click)="cancel()">{{ 'button.avbryt' | translate }}</button>
    </div>`,
    styles: [`
    .otp-code {
      padding: 1rem 0;
    }
    .otp-code input {
      font-family: pt mono,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
      font-size: 2.5rem;
      text-align: center;
      text-transform: uppercase;
      text-align: center;
      width: 100%;
    }
  `],
    animations: [
        fadeOutAnimation
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NgbdOtpValidateModal {
  @Input() public requestId: string;
  public otp: string;

  constructor(
    public activeModal: NgbActiveModal,
    public auth: AuthService) {
  }

  public ok(): void {
    this.activeModal.close({ requestId: this.requestId, otp: this.otp });
  }

  public cancel(): void {
    this.activeModal.close();
  }
}
